import { createMongoAbility } from '@casl/ability'

export type Actions = 'create' | 'read' | 'update' | 'delete' | 'manage'

/**
 * `Post` and `Comment` are Vuexy template leftovers, kept only because the demo
 * pages still reference them. `AdminArea` is the real one: every nav entry and route is
 * tagged with it, which is what keeps a driver out of the back office at large.
 *
 * `Orders` is the one screen both roles reach. The page is the same; the rows a driver
 * gets back are scoped server-side to the orders assigned to them, and the controls that
 * are not theirs to press are hidden. A shared subject rather than widening `AdminArea`,
 * so admitting a driver to one page does not admit them to the rest of it.
 */
export type Subjects =
  | 'Post'
  | 'Comment'
  | 'AdminArea'
  | 'Orders'
  | 'all'

export interface Rule {
  action: Actions
  subject: Subjects
}

export const ability = createMongoAbility<[Actions, Subjects]>()
